import { render, staticRenderFns } from "./aboutCenFzls.vue?vue&type=template&id=4fb108e4&scoped=true"
import script from "./aboutCenFzls.vue?vue&type=script&lang=js"
export * from "./aboutCenFzls.vue?vue&type=script&lang=js"
import style0 from "./aboutCenFzls.vue?vue&type=style&index=0&id=4fb108e4&prod&lang=css"
import style1 from "./aboutCenFzls.vue?vue&type=style&index=1&id=4fb108e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb108e4",
  null
  
)

export default component.exports